const mappings = {
  'greendrive': 'greendrive',
  'hidden': undefined,
  'redirect_lift': undefined,
  'warranty_name': undefined,// { items:string[]|string }
  'parseBadge': undefined,
  'brand_name': 'brand_name',
  'mainImage': 'mainImage',
  'year': 'year',
  'mileageF': 'mileageF',
  'city_name': 'city_name',
  'car_category_name': 'car_category_name',
  'monthly': 'monthly',
  'price': 'price',
  'car_name': 'carName',
  'model_name': 'model_name',
  'brand_listlink': 'listlink'
}

/**
 * Convert Laakkonen carsearch data to Bavarias car card suitable format.
 * @param {object} carData - Single car's data row from Laakkonen car searc
 * @return {object} carData ready to be rendered with Bavaria car cards
 */
export default (carData) => {

  const exportData = {};

  Object.keys( mappings ).forEach(targetField => {
    const sourceField = mappings[targetField];

    if( sourceField ) {
      if( typeof sourceField === 'function' ) {
        exportData[targetField] = sourceField( carData );
      } else {
        exportData[targetField] = carData[sourceField];
      }
    }
  });

  console.log(exportData);

  return exportData;
}
